import React, { useState }  from 'react'

import moment from "moment"
import toastr from 'toastr'

import { Modal } from 'react-bootstrap'
import { InputGroup, InputNumber } from 'rsuite'

import { database } from '../index.js'
import { useProducts, PRODUCT_LABELS } from '../products'
import { isValidEmail, showError } from '../validation'


const OrderModal = ({showModal, setShowModal, orderedProduct, orderedVolume}) => {

  const [ name, setName ] = useState('')
  const [ phone, setPhone ] = useState('')
  const [ email, setEmail ] = useState('')
  const [ volume, setVolume] = useState(orderedVolume || '')
  const [ product, setProduct] = useState(orderedProduct || '')
  const [ qty, setQty] = useState(1)

  const products = useProducts()

  // One entry per product value written to Orders; sold out only when every
  // variant behind it is sold out (honey has four).
  const productOptions = []
  products.forEach((item) => {
    const existing = productOptions.find((option) => option.value === item.product)
    if (existing) {
      existing.soldOut = existing.soldOut && item.soldOut
      return
    }
    productOptions.push({ value: item.product, soldOut: item.soldOut })
  })

  const honeyVolumes = products.filter((item) => item.product === 'Honey')

  const label = (text, soldOut) => soldOut ? text + ' (Sold out)' : text

  const handleChange = (e, field) => {
    switch (field) {
      case 'name':
        setName(e.target.value);
        break;
      case 'phone':
        setPhone(e.target.value);
        break;
      case 'email':
        setEmail(e.target.value);
        break;
      case 'product':
        setProduct(e.target.value);
        break;
      case 'volume':
        setVolume(e.target.value);
        break;
      case 'qty':
        setQty(e);
        break;
    }
  }

  const inputRef = React.createRef();
  const handleMinus = () => {
    inputRef.current.handleMinus();
  };
  const handlePlus = () => {
    inputRef.current.handlePlus();
  };

  const sendOrder = () => {
    // Optional here — an order can be placed with a phone number alone — but a
    // typo in a filled-in address should not pass silently.
    if (email.trim() && !isValidEmail(email)) {
      showError('Please enter a valid email address, for example name@example.com, or leave the field empty')
      return
    }

    const path = "Orders/" + moment().format('YYYY-MM-DD')
    const newOrderKey  = database.ref().child(path).push().key
    const updates = {}
    updates[path + "/" + newOrderKey] = {
      name: name,
      phone: phone,
      email: email,
      volume: volume,
      product: product,
      qty: qty
    }
    database.ref().update(updates).then(() => {
      setShowModal(!showModal)
      toastr.success('Success! We will contact you soon 😄', '', {
        "positionClass": "toast-top-center",
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
      })
    })
  }

  return(
    <Modal show={showModal} onHide={setShowModal} className='order-modal'>
      <Modal.Header closeButton>
        Order info
      </Modal.Header>
      <Modal.Body>

        <form action={(e)=> e.preventDefault()}>
          <input
            type="text"
            placeholder='Name'
            value={name}
            onChange={(e)=> handleChange(e, 'name')}
          />
          <input
            type="number"
            placeholder='Phone'
            value={phone}
            onChange={(e)=> handleChange(e, 'phone')}
          />
          <input
            type="text"
            placeholder='Email'
            value={email}
            onChange={(e)=> handleChange(e, 'email')}
          />
          <select
            name=""
            id=""
            value={product}
            onChange={(e)=> handleChange(e, 'product')}
          >
            {productOptions.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.soldOut}
              >
                {label(PRODUCT_LABELS[option.value] || option.value, option.soldOut)}
              </option>
            ))}
          </select>

          {product === 'Honey' &&
            <select
              name=""
              id=""
              value={volume}
              onChange={(e)=>
              handleChange(e, 'volume')}
            >
              <option value="Volume">Volume</option>
              {honeyVolumes.map((item) => (
                <option
                  key={item.id}
                  value={item.volume}
                  disabled={item.soldOut}
                >
                  {label(item.unit, item.soldOut)}
                </option>
              ))}
            </select>
          }

          <div className='label-and-input'>
            <p>Qty</p>
            <InputGroup className='modal-input-block'>
              <InputGroup.Button onClick={handleMinus}>
                -
              </InputGroup.Button>
              <InputNumber
                ref={inputRef}
                max={99}
                min={1}
                value={qty}
                onChange={(e)=> handleChange(e, 'qty')}
              />
              <InputGroup.Button onClick={handlePlus}>
                +
              </InputGroup.Button>
            </InputGroup>
          </div>

          <button
            className="common-button_orange"
            onClick={(e)=> {
              e.preventDefault()
              sendOrder()
            }}
          >
            Confirm
          </button>
        </form>

      </Modal.Body>
    </Modal>
  )
}

export default OrderModal
